import { render, staticRenderFns } from "./BaseMinicart.vue?vue&type=template&id=0a58c445&"
import script from "./BaseMinicart.vue?vue&type=script&lang=js&"
export * from "./BaseMinicart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/salesforce/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a58c445')) {
      api.createRecord('0a58c445', component.options)
    } else {
      api.reload('0a58c445', component.options)
    }
    module.hot.accept("./BaseMinicart.vue?vue&type=template&id=0a58c445&", function () {
      api.rerender('0a58c445', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/BaseMinicart.vue"
export default component.exports